var exports = {
  "Sc": "UserArea.module__userAreaInnerWrapper___OWpZSE",
  "cU": "UserArea.module__userAreaContainer___OWpZSE",
  "jC": "UserArea.module__popoutContainer___OWpZSE",
  "oT": "UserArea.module__voiceConnectionWrapper___OWpZSE",
  "eF": "UserArea.module__userInfo___OWpZSE",
  "vu": "UserArea.module__active___OWpZSE",
  "N6": "UserArea.module__userInfoText___OWpZSE",
  "nT": "UserArea.module__userName___OWpZSE",
  "ag": "UserArea.module__userStatus___OWpZSE",
  "uh": "UserArea.module__userStatusLabel___OWpZSE" + " " + "UserArea.module__userStatus___OWpZSE",
  "XW": "UserArea.module__userCustomStatus___OWpZSE" + " " + "UserArea.module__userStatus___OWpZSE",
  "oM": "UserArea.module__hoverRoll___OWpZSE",
  "n6": "UserArea.module__defaultState___OWpZSE",
  "yo": "UserArea.module__hovered___OWpZSE",
  "EE": "UserArea.module__forceHover___OWpZSE",
  "gO": "UserArea.module__controlsContainer___OWpZSE",
  "uH": "UserArea.module__controlButton___OWpZSE",
  "DY": "UserArea.module__contextMenuHover___OWpZSE",
  "r9": "UserArea.module__disabled___OWpZSE",
  "pd": "UserArea.module__controlIcon___OWpZSE",
  "se": "UserArea.module__controlIconWithDot___OWpZSE",
  "PP": "UserArea.module__controlDot___OWpZSE",
};

module.exports = exports;
